import { render, staticRenderFns } from "./bill.vue?vue&type=template&id=084360de&scoped=true&"
import script from "./bill.vue?vue&type=script&lang=ts&"
export * from "./bill.vue?vue&type=script&lang=ts&"
import style0 from "./bill.vue?vue&type=style&index=0&id=084360de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084360de",
  null
  
)

export default component.exports